@if (selectedSubmit && maxSelected == 1) {
  <question-description
    titleDir="left"
    subTitleDir="left"
    title="Pour qui souscrivez-vous ?"
    subTitle=""
  >
  </question-description>
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
    @if (enabledPhysicalOwnerSelection()) {
      <div class="tap-main">
        <span class="tap-text"> Personnes physiques </span>
      </div>
      <div
        class="physiques"
        [ngClass]="{
          pointer_events_none:
            form.value?.companyOwnerIds && form.value?.companyOwnerIds?.length,
        }"
      >
        <ng-container>
          <pr-checkbox-group
            formControlName="physicalOwnerIds"
            [options]="ownerOptionsPhysical"
            [asToggle]="true"
          >
          </pr-checkbox-group>
        </ng-container>
      </div>
    }
    <div
      class="morales"
      [ngClass]="{
        pointer_events_none:
          form.value?.physicalOwnerIds && form.value?.physicalOwnerIds?.length,
      }"
    >
      @if (ownerCompanyOptions?.length) {
        <div class="tap-main mt">
          <span class="tap-text"> Personnes morales </span>
        </div>
        <pr-checkbox-group
          formControlName="companyOwnerIds"
          [options]="ownerCompanyOptions"
        >
        </pr-checkbox-group>
      }
    </div>
    <div class="btn-group">
      <pr-button
        size="lg"
        type="button"
        label="Question précédente"
        icon="arrow_left"
        (onClick)="onPrev()"
      ></pr-button>
      <pr-button
        size="lg"
        type="submit"
        display="neutral"
        label="Je détermine mon profil."
      ></pr-button>
    </div>
  </form>
}
